import React, { useContext, useEffect, useState } from 'react'
import ReactDOM from 'react-dom';
import { ReportIcon, RightArrowIcon,} from 'assests/GmsIcons';
import { NONE,  PAGE_TITLE } from './AnalyticsConstants';
import CustomLayoutDialog from './Components/CustomLayoutDialog';
import { useHistory } from 'react-router-dom';
import { ChartTypes } from './Components/ChartTypes';
import AnalyticsHeader from './AnalyticsHeader';
import { AnalyticsContext } from './Context/AnalyticsContext';
import MetricComponent from './Components/MetricComponent';
import { AppContext } from 'Context/AppContext';
import { areAllChartDataAndCombinedDataEmpty, isMetricDataEmpty } from './AnalyticsHelper';
import GridListToggle from './Components/GridListToggle';
import CompatioLoader from 'Components/Common/components/CompatioLoader';
import { Metric } from './analytics';
import ChartWrapper from './Charts/ChartWrapper';

const AnalyticsPage = () => {
    const history = useHistory();
    const appData = useContext(AppContext);
    const context = useContext(AnalyticsContext);
    const [isGridView, setIsGridView] = useState(true);
   // const [showDialog, setShowDialog] = useState<boolean>(false);
    const [showLayoutDialog, setShowLayoutDialog] = useState<boolean>(false);
    const [selectedChartItem, setSelectedChartItem] = useState<string>("Line Chart");
    //const [menuData, setMenuData] = useState<TAppParentMenuItem[]>([]);
    //const [selectedDateRange, setSelectedDateRange] = useState<DateRange>({startDate: new Date(), endDate: new Date(),});
    //const handleDateRangeChange = (range: DateRange) => setSelectedDateRange(range);
    //const openDialog = () => setShowDialog(true);
    //const openLayoutDialog = () => setShowLayoutDialog(true);
    //const closeDialog = () => setShowDialog(false); 
    const closeLayoutDialog = () => setShowLayoutDialog(false);

    useEffect(() => {
        if (!appData?.pm?.checkPermission("analytics_read")) {
            history.push("/workspace/module/permission/denied");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);    
    
    const modalRoot = document.querySelector('#modal-root');

    return (
        <React.Fragment>
            <AnalyticsHeader pageTitle={PAGE_TITLE} />
            {/* { (showDialog && modalRoot) && ReactDOM.createPortal(<DateRangePickerDialog onChange={handleDateRangeChange} onClose={closeDialog} isOpen={showDialog} />, modalRoot)} */}
            { (showLayoutDialog && modalRoot) && ReactDOM.createPortal(<CustomLayoutDialog onClose={closeLayoutDialog}/>, modalRoot)}
            <div className={`tw-box-border tw-w-auto tw-h-px tw-border-t-[1px] tw-border-solid tw-border-[#D1D1D6]`} />
            {!context.showLoader && context?.applicationMetrics?.data && context?.applicationMetrics?.data?.length !== 0 ? <div className={`tw-flex tw-items-center tw-gap-2 tw-mt-2`}>
                <h3 className={`tw-text-sm tw-leading-[25.2px] tw-font-semibold tw-text-[#707275]`}>Summary</h3>
                {/* <SettingsIcon/> */}
            </div> : null}
            
            {context.showLoader ? <CompatioLoader /> : null }

            {!context.showLoader && context?.applicationMetrics?.data && context?.applicationMetrics?.data?.length !== 0 && context.applicationMetrics.data.map((application:any, index: number) => {
                return (
                    <React.Fragment key={application?.application_name + index}>
                        <div className={`tw-mt-3 tw-text-base tw-font-semibold tw-text-slategray`}>
                            {application?.application_name ?? "--"}
                        </div>
                        <div className={`tw-flex tw-flex-wrap tw-gap-4 tw-mt-2`}>
                            {application?.metrics?.map((metric:Metric, index: number) => {                                 
                                return (
                                    <React.Fragment key={metric?.name + index}>
                                        <div onClick={() => {
                                            history.push(`/gms/performance/detail/${metric?.name}`);
                                            context.setComingFromDetailPage(false);
                                            }} className={`tw-p-2.5 tw-rounded tw-box-border tw-w-[212px] tw-h-[74px] tw-border-[1px] tw-border-solid tw-border-lightgray tw-flex-wrap hover:tw-bg-[#dee3f6] tw-cursor-pointer`}>
                                            <div className={`tw-flex tw-items-center tw-justify-between`}>
                                                <label className={`tw-text-[#707275] tw-text-xs tw-font-semibold`}>{metric?.name}</label>
                                                <RightArrowIcon />
                                            </div>
                                            <MetricComponent metricValue={metric?.value ?? 0} percentage={metric?.percentage_change ?? 0.0} compareTo={context.selectedCompareMenuItem} metricName={metric?.name}/> 
                                        </div>
                                    </React.Fragment>
                                )})
                            }
                        </div>
                    </React.Fragment> 
                );
            })} 
            {!context.showLoader && context?.applicationMetrics?.data && context?.applicationMetrics?.data?.length !== 0 && !context.showGraphLoader && context.graphData && context.graphData.length > 0 ? <div className='tw-flex tw-justify-end tw-mt-2'>
                <GridListToggle isGridView={isGridView} setIsGridView={setIsGridView} />
            </div> : null}
            {context.showGraphLoader ? <CompatioLoader /> : null}
            
            {!context.showLoader && !context.showGraphLoader ? (
                <div className={`tw-grid ${isGridView ? 'tw-grid-cols-2' : 'tw-grid-cols-1'} tw-gap-4 tw-my-4 tw-transition tw-duration-300`}>
                    {context.graphData && context.graphData.length > 0 && context.graphData.map((data: any, index: number) => (
                        <React.Fragment key={`fragment-${data.metric_name}-${index}`}>
                            {data.chartData.length > 0 && data.combinedData.length > 0 ? (
                                <div className={`tw-rounded tw-bg-greys-000 tw-shadow-[0px_4px_12px_rgba(0,_0,_0,_0.08)] tw-box-border tw-w-auto tw-h-auto tw-border-[1px] tw-border-solid tw-border-lightgray`}>
                                    <div className={`tw-flex tw-justify-between tw-items-center tw-pt-2 tw-px-2`}>
                                        <label className={`tw-text-sm tw-ps-1 tw-font-medium tw-text-[#091E42]`}>{data.metric_name}</label>
                                        <div className={`tw-flex tw-items-center tw-gap-1 tw-pe-2`}>
                                            <span className='tw-cursor-pointer' onClick={() => { 
                                                history.push(`/gms/performance/detail/${data.metric_name}`); 
                                                context.setComingFromDetailPage(false);}}>
                                                <ReportIcon />
                                            </span>
                                            {context.selectedCompareMenuItem === NONE ? (<ChartTypes selectedItem={selectedChartItem} setSelectedItem={setSelectedChartItem}/> ) : null} 
                                        </div>
                                    </div>
                                <div className={`tw-box-border tw-w-auto tw-h-px tw-border-t-[1px] tw-border-solid tw-border-[#D1D1D6] tw-mt-2`} /> 
                                <ChartWrapper
                                    chartType={selectedChartItem}
                                    compareType={context.selectedCompareMenuItem}
                                    data={data.chartData}
                                    combinedData={data.combinedData}
                                    dashedArray={data.dashedArray}
                                    metricName={data.metric_name}
                                    xAxis={data?.xAxis}
                                    granularity={context?.payload?.granularity}
                                    timezone={context?.selectedTimezone?.name}
                                />
                            </div>
                    ) : null}
                    </React.Fragment>
                ))}
            </div>
        ) : null}

            {!context.showLoader && isMetricDataEmpty(context?.applicationMetrics) && areAllChartDataAndCombinedDataEmpty(context.graphData) ?
                <div className={`tw-flex tw-flex-col tw-items-center tw-justify-center`}>
                    <img className={`tw-w-auto tw-h-[180px]`} src={process.env.PUBLIC_URL + "/img/place_holder_no_data.svg"} alt="logo" />
                    <label className={`tw-text-[24px] tw-text-[#091caa] tw-font-semibold`}>No Data Found</label>
                </div>
            : null}            

        </React.Fragment>
    )
}

export default AnalyticsPage;